<template>
  <div>资源</div>
</template>

<script>
export default {
  name: "Resources"
}
</script>

<style scoped>

</style>
